/*
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: kongweiqiang
 * @LastEditTime: 2021-09-03 15:28:52
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VideoPlayer from 'vue-video-player'
import {
  post,
  get, put,
  baseURL
} from './api/http'

Vue.use(ElementUI)
Vue.config.productionTip = false
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
// 定义全局变量
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$put = put
Vue.prototype.$baseURL = baseURL

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
